// PatternFlow — SVG icon dictionary
// Exposed as window.PATTERNFLOW_ICONS. Loaded before patternflow.js.

(function () {
  'use strict';

  window.PATTERNFLOW_ICONS = {
    // Category icons
    mens: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"/></svg>',
    womens: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"/></svg>',
    kids: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"/></svg>',
    babies: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 8.25c0 2.485-2.099 4.5-4.688 4.5-1.935 0-3.597-1.126-4.312-2.733-.715 1.607-2.377 2.733-4.313 2.733C5.1 12.75 3 10.735 3 8.25m9-4.5v4.5m0 0c0 3.866-3.582 7.5-7.5 7.5m7.5-7.5c0 3.866 3.582 7.5 7.5 7.5M12 8.25V3.75"/><circle cx="12" cy="18" r="2.25"/></svg>',

    // Product type icons
    tee: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 3L4 7l2 1v10a1 1 0 001 1h10a1 1 0 001-1V8l2-1-4-4H8z"/></svg>',
    singlet: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 3v2a3 3 0 006 0V3m-6 0H7a1 1 0 00-1 1v15a1 1 0 001 1h10a1 1 0 001-1V4a1 1 0 00-1-1h-2m-6 0h6"/></svg>',
    shirt: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 3l-4 4 2 1v10a1 1 0 001 1h10a1 1 0 001-1V8l2-1-4-4H8zm4 0v5"/></svg>',
    blouse: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 3l-4 4 2 1v10a1 1 0 001 1h10a1 1 0 001-1V8l2-1-4-4H8zm4 0v3"/></svg>',
    hoodie: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 3l-4 4 2 1v10a1 1 0 001 1h10a1 1 0 001-1V8l2-1-4-4H8z"/><path d="M9 3c0 1.657 1.343 3 3 3s3-1.343 3-3"/></svg>',
    jumper: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 3l-4 4 2 1v10a1 1 0 001 1h10a1 1 0 001-1V8l2-1-4-4H8z"/></svg>',
    jacket: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 3L3 7l2 1v10a1 1 0 001 1h12a1 1 0 001-1V8l2-1-5-4H8z"/><path d="M12 3v16"/></svg>',
    tailored: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 3L3 7l2 1v10a1 1 0 001 1h12a1 1 0 001-1V8l2-1-5-4H8z"/><path d="M12 3v16m-3 0l3-5 3 5"/></svg>',
    shorts: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 4h14a1 1 0 011 1v5l-3 6H7L4 10V5a1 1 0 011-1z"/><path d="M12 4v12"/></svg>',
    pants: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 3h14a1 1 0 011 1v4l-3 12H7L4 8V4a1 1 0 011-1z"/><path d="M12 3v17"/></svg>',
    leggings: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 3h12a1 1 0 011 1v3l-2 13H7L5 7V4a1 1 0 011-1z"/><path d="M12 3v17"/></svg>',
    dress: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 3l-4 4 2 1-1 11a1 1 0 001 1h12a1 1 0 001-1l-1-11 2-1-4-4H8z"/></svg>',
    skirt: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6h12l2 13a1 1 0 01-1 1H5a1 1 0 01-1-1L6 6z"/><path d="M6 6a6 6 0 0112 0"/></svg>',
    brief: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 6h14a1 1 0 011 1v3c0 5-3 8-8 10-5-2-8-5-8-10V7a1 1 0 011-1z"/></svg>',
    croptop: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 3l-4 4 2 1v4a1 1 0 001 1h10a1 1 0 001-1V8l2-1-4-4H8z"/></svg>',
    onepiece: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M8 3l-4 4 2 1v11a1 1 0 001 1h10a1 1 0 001-1V8l2-1-4-4H8z"/><path d="M6 12h12"/></svg>',

    // Refinement icons
    setin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 3v8M8 3l-5 5h5m8-5l5 5h-5"/><rect x="6" y="11" width="12" height="9" rx="1"/></svg>',
    raglan: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 3v8M8 3L3 8l3 3m8-8l5 5-3 3"/><rect x="6" y="11" width="12" height="9" rx="1"/></svg>',
    sleeveless: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 3v5"/><rect x="7" y="5" width="10" height="14" rx="1"/><path d="M7 8a3 3 0 010-6m10 6a3 3 0 000-6" stroke-dasharray="2 2"/></svg>',
    pullon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 3v18m-6-6l6-6 6 6"/><rect x="5" y="3" width="14" height="4" rx="1"/></svg>',
    zip: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 3v18"/><path d="M9 6l3 3 3-3M9 12l3 3 3-3M9 18l3 3 3-3"/></svg>',

    // Misc
    compare: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"/></svg>',
    browse: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zm0 9.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zm0 9.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25a2.25 2.25 0 01-2.25-2.25v-2.25z"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="40" height="40"><path d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>',
    warning: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="40" height="40"><path d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"/></svg>',
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="40" height="40"><path d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"/></svg>',
    external: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><path d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"/></svg>'
  };

  // Default key mappings — keep in sync with the original demo
  window.PATTERNFLOW_ICON_MAPS = {
    productType: {
      'Tee': 'tee', 'Singlet': 'singlet', 'Shirt': 'shirt',
      'Blouse / Top': 'blouse', 'Hoodie': 'hoodie', 'Jumper': 'jumper',
      'Casual Jacket': 'jacket', 'Tailored Jacket': 'tailored', 'Jacket': 'jacket',
      'Shorts': 'shorts', 'Pants': 'pants', 'Leggings': 'leggings',
      'Dress': 'dress', 'Skirt': 'skirt', 'Brief': 'brief',
      'Crop Top': 'croptop', 'One Piece': 'onepiece'
    },
    step4: {
      'Set-In Armhole': 'setin', 'Raglan Armhole': 'raglan',
      'Sleeveless': 'sleeveless', 'Pull-On': 'pullon', 'Zip': 'zip'
    },
    category: {
      'Mens': 'mens', 'Womens': 'womens', 'Kids': 'kids', 'Babies': 'babies'
    }
  };

  // ================================================================
  // Category-specific garment silhouettes (Requirement 1)
  // ----------------------------------------------------------------
  // Built parametrically so each category (Mens/Womens/Kids/Babies)
  // gets a visibly distinct shape per garment. Keys are `cat_garment`
  // (e.g. mens_tee, womens_dress). patternflow.js prefers these over
  // the generic per-type icons via ICON_MAPS.productTypeByCategory.
  // These are schematic placeholders — merchants can override with
  // real per-category images later (no code change needed).
  //
  // Sport icons (Requirement 2) are added in the same pass.
  // ================================================================
  (function (ICONS, MAPS) {
    function svg(inner) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="1.4" stroke-linejoin="round" stroke-linecap="round">' + inner + '</svg>';
    }
    function n(v) { return Math.round(v * 100) / 100; }

    // Per-category body proportions (half-widths around centre x=12).
    // Mens = boxy/broad, Womens = nipped waist + flared hem, Kids = smaller,
    // Babies = short & rounded with snap details on bottoms.
    var P = {
      mens:   { SH: 6.6, WA: 6.2, HM: 6.3, TY: 7.0, HY: 19.5, neck: 2.2 },
      womens: { SH: 5.7, WA: 4.3, HM: 6.7, TY: 7.0, HY: 19.5, neck: 2.6 },
      kids:   { SH: 5.5, WA: 5.2, HM: 5.7, TY: 8.0, HY: 18.0, neck: 2.0 },
      babies: { SH: 5.2, WA: 5.3, HM: 5.5, TY: 8.5, HY: 16.5, neck: 2.0 }
    };

    // Upper-body garment outline (returns inner SVG markup).
    function top(p, o) {
      o = o || {};
      var c = 12, sh = p.SH, wa = p.WA,
          hm = o.hm != null ? o.hm : p.HM,
          ty = p.TY, hy = o.hy != null ? o.hy : p.HY,
          neck = o.neck != null ? o.neck : p.neck,
          ym = (ty + hy) / 2,
          cap = o.cap != null ? o.cap : 2.2,
          sl = o.sleeve != null ? o.sleeve : 1.8;
      var d = 'M ' + n(c - neck) + ' ' + n(ty) +
        ' L ' + n(c - sh) + ' ' + n(ty) +
        ' L ' + n(c - sh - sl) + ' ' + n(ty + cap) +
        ' L ' + n(c - sh + 0.6) + ' ' + n(ty + cap + 1.7) +
        ' L ' + n(c - wa) + ' ' + n(ym) +
        ' L ' + n(c - hm) + ' ' + n(hy) +
        ' L ' + n(c + hm) + ' ' + n(hy) +
        ' L ' + n(c + wa) + ' ' + n(ym) +
        ' L ' + n(c + sh - 0.6) + ' ' + n(ty + cap + 1.7) +
        ' L ' + n(c + sh + sl) + ' ' + n(ty + cap) +
        ' L ' + n(c + sh) + ' ' + n(ty) +
        ' L ' + n(c + neck) + ' ' + n(ty) +
        ' L ' + n(c) + ' ' + n(ty + 1.5) + ' Z';
      var extra = '';
      if (o.hood) extra += '<path d="M ' + n(c - neck) + ' ' + n(ty) + ' Q ' + c + ' ' + n(ty - 3) + ' ' + n(c + neck) + ' ' + n(ty) + '"/>';
      if (o.openFront) extra += '<path d="M ' + c + ' ' + n(ty + 1.5) + ' L ' + c + ' ' + n(hy) + '"/>';
      if (o.lapel) extra += '<path d="M ' + n(c - neck) + ' ' + n(ty) + ' L ' + n(c - 1.2) + ' ' + n(ty + 3) + ' M ' + n(c + neck) + ' ' + n(ty) + ' L ' + n(c + 1.2) + ' ' + n(ty + 3) + '"/>';
      return '<path d="' + d + '"/>' + extra;
    }

    // Sleeveless garment (singlet / tank / crop) — straps, no sleeves.
    function tank(p, o) {
      o = o || {};
      var c = 12, sh = p.SH - 1.4, wa = p.WA,
          hm = o.hm != null ? o.hm : p.HM,
          ty = p.TY, hy = o.hy != null ? o.hy : p.HY,
          ym = (ty + hy) / 2, strap = 1.6;
      var d = 'M ' + n(c - strap) + ' ' + n(ty - 0.5) +
        ' L ' + n(c - sh) + ' ' + n(ty + 1.5) +
        ' L ' + n(c - wa) + ' ' + n(ym) +
        ' L ' + n(c - hm) + ' ' + n(hy) +
        ' L ' + n(c + hm) + ' ' + n(hy) +
        ' L ' + n(c + wa) + ' ' + n(ym) +
        ' L ' + n(c + sh) + ' ' + n(ty + 1.5) +
        ' L ' + n(c + strap) + ' ' + n(ty - 0.5);
      return '<path d="' + d + '"/>';
    }

    // Bottoms with two legs (pants / leggings / shorts).
    function legs(p, o) {
      o = o || {};
      var c = 12, w = o.w != null ? o.w : p.HM - 0.4,
          ty = o.ty != null ? o.ty : p.TY + 0.5,
          hy = o.hy != null ? o.hy : 21,
          gap = o.gap != null ? o.gap : 1.0,
          crotch = ty + (hy - ty) * 0.42;
      var d = 'M ' + n(c - w) + ' ' + n(ty) +
        ' L ' + n(c + w) + ' ' + n(ty) +
        ' L ' + n(c + w - 0.3) + ' ' + n(hy) +
        ' L ' + n(c + gap) + ' ' + n(hy) +
        ' L ' + n(c) + ' ' + n(crotch) +
        ' L ' + n(c - gap) + ' ' + n(hy) +
        ' L ' + n(c - w + 0.3) + ' ' + n(hy) + ' Z';
      var extra = '<path d="M ' + n(c - w) + ' ' + n(ty + 1.4) + ' L ' + n(c + w) + ' ' + n(ty + 1.4) + '"/>';
      if (o.snap) extra += '<circle cx="' + n(c - 1) + '" cy="' + n(crotch + 0.7) + '" r="0.5"/><circle cx="' + n(c + 1) + '" cy="' + n(crotch + 0.7) + '" r="0.5"/>';
      return '<path d="' + d + '"/>' + extra;
    }

    // Skirt — flared trapezoid with waistband.
    function skirt(p) {
      var c = 12, t = p.WA - 0.6, b = p.HM + 1.6, ty = p.TY + 1, hy = 20;
      return '<path d="M ' + n(c - t) + ' ' + n(ty) + ' L ' + n(c + t) + ' ' + n(ty) +
        ' L ' + n(c + b) + ' ' + n(hy) + ' L ' + n(c - b) + ' ' + n(hy) + ' Z"/>' +
        '<path d="M ' + n(c - t) + ' ' + n(ty + 1.3) + ' L ' + n(c + t) + ' ' + n(ty + 1.3) + '"/>';
    }

    // Brief.
    function brief(p) {
      var c = 12, w = p.WA, ty = p.TY + 3;
      return '<path d="M ' + n(c - w) + ' ' + n(ty) + ' L ' + n(c + w) + ' ' + n(ty) +
        ' L ' + n(c + w - 1) + ' ' + n(ty + 2.5) +
        ' Q ' + c + ' ' + n(ty + 5.5) + ' ' + n(c - w + 1) + ' ' + n(ty + 2.5) + ' Z"/>';
    }

    var build = {
      tee:      function (p) { return top(p, { sleeve: 1.8, cap: 2.2 }); },
      singlet:  function (p) { return tank(p, {}); },
      shirt:    function (p) { return top(p, { sleeve: 2.6, cap: 2.6, openFront: true, neck: 1.6 }); },
      blouse:   function (p) { return top(p, { sleeve: 1.4, cap: 2.0, neck: 3.0 }); },
      hoodie:   function (p) { return top(p, { sleeve: 2.6, cap: 2.6, hood: true }); },
      jumper:   function (p) { return top(p, { sleeve: 2.6, cap: 2.6 }); },
      jacket:   function (p) { return top(p, { sleeve: 2.8, cap: 2.8, openFront: true }); },
      tailored: function (p) { return top(p, { sleeve: 2.8, cap: 2.8, openFront: true, lapel: true }); },
      croptop:  function (p) { return tank(p, { hy: p.TY + 5 }); },
      dress:    function (p) { return top(p, { sleeve: 1.4, cap: 2.0, hy: 21.5, hm: p.HM + 2.2 }); },
      onepiece: function (p) { return top(p, { sleeve: 1.6, cap: 2.0, hy: 13.5, hm: p.HM - 1.0 }) +
                                      legs(p, { ty: 13, hy: 20, w: p.HM - 1.4, snap: p === P.babies }); },
      shorts:   function (p) { return legs(p, { hy: 15.5, snap: p === P.babies }); },
      pants:    function (p) { return legs(p, { hy: 21, w: p.HM - 0.8, snap: p === P.babies }); },
      leggings: function (p) { return legs(p, { hy: 21, w: p.HM - 1.6, gap: 0.7 }); },
      skirt:    function (p) { return skirt(p); },
      brief:    function (p) { return brief(p); }
    };

    ['mens', 'womens', 'kids', 'babies'].forEach(function (cat) {
      var p = P[cat];
      Object.keys(build).forEach(function (g) { ICONS[cat + '_' + g] = svg(build[g](p)); });
    });

    // Map every category × productType label to its generated silhouette key.
    var ptBase = {
      'Tee': 'tee', 'Singlet': 'singlet', 'Shirt': 'shirt', 'Blouse / Top': 'blouse',
      'Hoodie': 'hoodie', 'Jumper': 'jumper', 'Casual Jacket': 'jacket', 'Tailored Jacket': 'tailored',
      'Jacket': 'jacket', 'Knit Jacket': 'jacket', 'Shorts': 'shorts', 'Pants': 'pants',
      'Leggings': 'leggings', 'Dress': 'dress', 'Skirt': 'skirt', 'Brief': 'brief',
      'Crop Top': 'croptop', 'One Piece': 'onepiece'
    };
    MAPS.productTypeByCategory = {};
    ['Mens', 'Womens', 'Kids', 'Babies'].forEach(function (cat) {
      var m = {};
      Object.keys(ptBase).forEach(function (pt) { m[pt] = cat.toLowerCase() + '_' + ptBase[pt]; });
      MAPS.productTypeByCategory[cat] = m;
    });

    // ---- Sport icons (Requirement 2) ----
    ICONS.hockey = svg('<path d="M5 4v8.5a4.5 4.5 0 004.5 4.5H12"/><path d="M11.5 17l4.5 2.5 2.2-3.4"/><circle cx="18.5" cy="6" r="1.4"/>');
    ICONS.baseball = svg('<circle cx="12" cy="12" r="8"/><path d="M7.6 6.4C9.2 9 9.2 15 7.6 17.6M16.4 6.4C14.8 9 14.8 15 16.4 17.6"/>');
    ICONS.soccer = svg('<circle cx="12" cy="12" r="8"/><path d="M12 7.6l3.3 2.4-1.3 3.9H9.9L8.7 10z"/><path d="M12 7.6V5.2M15.3 10l2.4-1.3M13.9 13.9l1.5 2.4M10.1 13.9l-1.5 2.4M8.7 10L6.3 8.7"/>');
    ICONS.volleyball = svg('<circle cx="12" cy="12" r="8"/><path d="M12 4c-2.6 3-2.6 13 0 16"/><path d="M4.3 9.8c3.6-1 12.1 1.5 15.1 6.3"/><path d="M4.3 14.2c3.6 1 12.1-1.5 15.1-6.3"/>');
    ICONS.aussiefootball = svg('<ellipse cx="12" cy="12" rx="8.5" ry="5"/><path d="M6.6 12h10.8"/><path d="M9 11v2M11 11v2M13 11v2M15 11v2"/>');
    ICONS.netball = svg('<ellipse cx="12" cy="5" rx="3" ry="1.2"/><circle cx="12" cy="13.5" r="5.6"/><path d="M6.4 13.5h11.2M12 7.9v11.2"/>');
    ICONS.athletics = svg('<ellipse cx="12" cy="12" rx="8.5" ry="5.5"/><ellipse cx="12" cy="12" rx="5" ry="2.6"/><path d="M3.5 12h3M17.5 12h3"/>');
    ICONS.swimming = svg('<path d="M3 9c1.8-1.6 3.6-1.6 5.4 0s3.6 1.6 5.4 0 3.6-1.6 5.2 0"/><path d="M3 13c1.8-1.6 3.6-1.6 5.4 0s3.6 1.6 5.4 0 3.6-1.6 5.2 0"/><path d="M3 17c1.8-1.6 3.6-1.6 5.4 0s3.6 1.6 5.4 0 3.6-1.6 5.2 0"/>');
    ICONS.cycling = svg('<circle cx="6" cy="16.5" r="3.3"/><circle cx="18" cy="16.5" r="3.3"/><path d="M6 16.5l4-6.5h5M9 10h5.5l3.5 6.5"/><path d="M13.5 10l-2 6.5"/><circle cx="14.5" cy="6.5" r="1.1"/>');
    ICONS.sport = svg('<circle cx="12" cy="12" r="8.2"/><path d="M12 3.8v16.4M3.8 12h16.4"/>');

    MAPS.sport = {
      'Ice Hockey': 'hockey', 'Baseball': 'baseball', 'Soccer': 'soccer',
      'Volleyball': 'volleyball', 'Aussie Football': 'aussiefootball',
      'Netball': 'netball', 'Athletics': 'athletics', 'Swimming': 'swimming',
      'Cycling': 'cycling'
    };
  })(window.PATTERNFLOW_ICONS, window.PATTERNFLOW_ICON_MAPS);
})();
